import { MutationHandlingServiceV2, NotificationService } from '@akebono/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { scrollToTop } from 'src/app/const';
import {
  CrooberCarTypesGQL,
  CrooberOrderCreateGQL,
  CrooberSearchGQL,
  CurrentUser,
  ExchangeRate,
} from 'src/app/graphql/user-service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { SearchService, SearchServiceEnum } from 'src/app/services/search.service';

@Component({
  selector: 'app-croober-search',
  templateUrl: './croober-search.component.html',
  styleUrls: ['./croober-search.component.scss'],
})
export class CrooberSearchComponent implements OnInit, OnDestroy {
  category: number | null = null;
  search: string | null = null;

  items: any = null;
  currentUser: CurrentUser = null;
  exchangeRate: ExchangeRate = null;

  loading = false;

  filter = {
    new_flag: null,
    free_shipping_flag: null,
    kakaku_low: null,
    kakaku_high: null,
    stars_division: null,
    sort: null,
    search_word: null,
    page: null,
    pageSize: null,
    category: null,
    partmaker: [],
    details: [],
    makerId: null,
    modelId: null,
  };

  subscription: Subscription = null;

  categories = [
    {
      label: 'Шины и диски',
      children: [
        {
          value: 'allRims',
          label: 'Все колеса',
          isLeaf: true,
        },
        {
          value: '01_10_01',
          label: 'Шины',
          isLeaf: true,
        },
        {
          value: '01_10_03',
          label: 'Зимняя шина',
          isLeaf: true,
        },
        {
          value: '01_20_01',
          label: 'Алюминиевые диски',
          isLeaf: true,
        },
        {
          value: '01_20_02',
          label: 'Стальные диски',
          isLeaf: true,
        },
        {
          value: '01_25_01',
          label: 'Шина на диске',
          isLeaf: true,
        },
        {
          value: '01_25_03',
          label: 'Зимняя шина на диске',
          isLeaf: true,
        },
        {
          value: '01_26_05',
          label: 'Прочие',
          isLeaf: true,
        },
      ],
    },
    {
      label: 'Автозвук',
      children: [
        {
          value: '01_30_01',
          label: 'Головное устройство',
          isLeaf: true,
        },
        {
          value: '01_30_02',
          label: 'Динамики',
          isLeaf: true,
        },
        {
          value: '01_30_03',
          label: 'Усилитель',
          isLeaf: true,
        },
        {
          value: '01_40_01',
          label: 'Навигация',
          isLeaf: true,
        },
        {
          value: '01_40_05',
          label: 'Навигация',
          isLeaf: true,
        },
        {
          value: '01_40_10',
          label: 'Монитор',
          isLeaf: true,
        },
        {
          value: '01_40_15',
          label: 'Монитор',
          isLeaf: true,
        },
        {
          value: '01_40_20',
          label: 'Монитор',
          isLeaf: true,
        },
        {
          value: '01_40_25',
          label: 'DVD проигрыватель',
          isLeaf: true,
        },
        {
          value: '01_40_30',
          label: 'Аксессуары',
          isLeaf: true,
        },
        {
          value: '01_40_35',
          label: 'Навигация',
          isLeaf: true,
        },
        {
          value: '01_40_40',
          label: 'Платежная система',
          isLeaf: true,
        },
      ],
    },
    {
      label: 'Тюнинг',
      children: [
        {
          value: '01_50_01',
          label: 'Ходовая часть',
          isLeaf: true,
        },
        {
          value: '01_50_10',
          label: 'Выхлопная система',
          isLeaf: true,
        },
        {
          value: '01_50_15',
          label: 'Электрика',
          isLeaf: true,
        },
        {
          value: '01_50_20',
          label: 'Лампочки',
          isLeaf: true,
        },
        {
          value: '01_50_25',
          label: 'Распорки',
          isLeaf: true,
        },
        {
          value: '01_50_30',
          label: 'Датчики',
          isLeaf: true,
        },
        {
          value: '01_50_35',
          label: 'Турбины',
          isLeaf: true,
        },
        {
          value: '01_50_40',
          label: 'Силовые агрегаты',
          isLeaf: true,
        },
        {
          value: '01_50_45',
          label: 'Система охлаждения',
          isLeaf: true,
        },
        {
          value: '01_50_50',
          label: 'Тормозная система',
          isLeaf: true,
        },
        {
          value: '01_50_55',
          label: 'Кузовные запчасти',
          isLeaf: true,
        },
        {
          value: '01_50_60',
          label: 'Салон',
          isLeaf: true,
        },
        {
          value: '01_50_65',
          label: 'Сиденья',
          isLeaf: true,
        },
        {
          value: '01_50_70',
          label: 'Багажники',
          isLeaf: true,
        },
        {
          value: '01_50_99',
          label: 'Прочее',
          isLeaf: true,
        },
      ],
    },
    {
      label: 'Товары для авто',
      children: [
        {
          value: '01_70_01',
          label: 'Автохимия',
          isLeaf: true,
        },
        {
          value: '01_70_10',
          label: 'Обслуживание',
          isLeaf: true,
        },
        {
          value: '01_70_20',
          label: 'Аксессуары',
          isLeaf: true,
        },
        {
          value: '01_70_99',
          label: 'Прочее',
          isLeaf: true,
        },
      ],
    },
  ];

  makers = [
    {
      id: 1,
      name: 'TOYOTA',
    },
    {
      id: 2,
      name: 'NISSAN',
    },
    {
      id: 3,
      name: 'HONDA',
    },
    {
      id: 4,
      name: 'MITSUBISHI',
    },
    {
      id: 5,
      name: 'MAZDA',
    },
    {
      id: 6,
      name: 'DAIHATSU',
    },
    {
      id: 7,
      name: 'SUZUKI',
    },
    {
      id: 8,
      name: 'SUBARU',
    },
    {
      id: 9,
      name: 'LEXUS',
    },
    {
      id: 10,
      name: 'ISUZU',
    },
    {
      id: 11,
      name: 'EUNOS',
    },
    {
      id: 101,
      name: 'BMW',
    },
    {
      id: 102,
      name: 'MERCEDES-BENZ',
    },
    {
      id: 103,
      name: 'AUDI',
    },
    {
      id: 104,
      name: 'VOLKSWAGEN',
    },
    {
      id: 105,
      name: 'PORSCHE',
    },
    {
      id: 106,
      name: 'VOLVO',
    },
    {
      id: 107,
      name: 'RENAULT',
    },
    {
      id: 108,
      name: 'PEUGEOT',
    },
    {
      id: 109,
      name: 'CHRYSLER-JEEP',
    },
    {
      id: 110,
      name: 'FERRARI',
    },
    {
      id: 111,
      name: 'MINI',
    },
    {
      id: 112,
      name: 'FIAT-AUTO',
    },
    {
      id: 113,
      name: 'CITROEN',
    },
    {
      id: 114,
      name: 'CHEVROLET',
    },
    {
      id: 115,
      name: 'FORD',
    },
    {
      id: 116,
      name: 'LAND ROVER',
    },
    {
      id: 117,
      name: 'JAGUAR',
    },
    {
      id: 118,
      name: 'ALFAROMEO',
    },
    {
      id: 119,
      name: 'ABARTH',
    },
    {
      id: 120,
      name: 'SMART',
    },
  ];
  models = [];
  partmakers = [];
  details = [];

  total = 0;
  buying = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private title: Title,
    private translate: TranslateService,
    private searchService: SearchService,
    private crooberSearchGQL: CrooberSearchGQL,
    private crooberCarTypes: CrooberCarTypesGQL,
    private googleTranslate: GoogleTranslateService,
    private crooberOrderCreateGQL: CrooberOrderCreateGQL,
    private mhs: MutationHandlingServiceV2,
    private ns: NotificationService,
  ) {}

  ngOnInit(): void {
    this.searchService.currentService.next(SearchServiceEnum.Croober);
    this.route.queryParams.subscribe((params) => {
      this.filter.page = Number(params.page || 1);
      this.filter.pageSize = Number(params.per_page || 20);
      if (params.new_flag) {
        this.filter.new_flag = Number(params.new_flag) === 1;
      }
      if (params.free_shipping_flag) {
        this.filter.free_shipping_flag = Number(params.free_shipping_flag) === 1;
      }
      if (params.c_bunrui_cd) {
        const category = params.c_bunrui_cd;
        this.filter.category = Array.isArray(category) ? category[0] : category;
      }
      if (params.q) {
        this.filter.search_word = params.q;
      }
      if (params.update_date === 'desc') {
        this.filter.sort = 'update_date';
      }
      if (params.arrival_date === 'desc') {
        this.filter.sort = 'arrival_date';
      }
      if (params.kakaku === 'asc') {
        this.filter.sort = 'price_up';
      }
      if (params.kakaku === 'desc') {
        this.filter.sort = 'price_down';
      }
      if (params.kakaku_low) {
        this.filter.kakaku_low = Number(params.kakaku_low);
      }
      if (params.kakaku_high) {
        this.filter.kakaku_high = Number(params.kakaku_high);
      }
      if (params.stars_division) {
        this.filter.stars_division = Number(params.stars_division) / 10;
      }
      if (params.star_rating === 'asc') {
        this.filter.sort = 'condition_up';
      }
      if (params.star_rating === 'desc') {
        this.filter.sort = 'condition_down';
      }
      if (params.shouhin_maker_id) {
        const ids = params.shouhin_maker_id.split(',');
        if (this.partmakers.length) {
          this.filter.partmaker = this.partmakers.filter((p) => ids.includes(p.name));
        } else {
          this.filter.partmaker = ids;
        }
      }
      if (params.s_bunrui_cd) {
        const ids = params.s_bunrui_cd.split(',');
        if (this.details.length) {
          this.filter.details = this.details.filter((p) => ids.includes(p.value));
        } else {
          this.filter.details = ids;
        }
      }
      if (params.compatible_vehicle_maker_id) {
        this.filter.makerId = Number(params.compatible_vehicle_maker_id) || null;
        this.onMakerChange(this.filter.makerId.toString());
      }
      if (params.compatible_vehicle_id) {
        this.filter.modelId = Number(params.compatible_vehicle_id) || null;
      }
      this.unsub();
      this.fetchSearch();
    });
  }

  fetchSearch(): void {
    this.loading = true;
    this.subscription = this.crooberSearchGQL
      .watch({
        path: this.normalizeQueryParams(window.location.search),
        categoryId: this.filter.category || '01',
      })
      .valueChanges.subscribe(
        (result) => {
          this.loading = false;
          console.log('Search response', result);

          if (result && result.data && result.data.crooberSearch) {
            this.items = result.data.crooberSearch.products;
            this.exchangeRate = result.data.exchangeRate;
            this.partmakers = result.data.crooberPartmakers.makerInitial;
            if (typeof this.filter.partmaker[0] === 'string') {
              this.filter.partmaker = this.partmakers.filter((p) =>
                this.filter.partmaker.includes(p.name),
              );
            }
            this.details = result.data.crooberPartmakers.detail || [];
            this.filter.details = this.details.filter((p) => {
              if (typeof this.filter.details[0] === 'string') {
                return this.filter.details.includes(p.value);
              } else {
                return this.filter.details.findIndex((d) => d.value === p.value) !== -1;
              }
            });

            this.total = Number(result.data.crooberSearch.total);

            this.title.setTitle(this.translate.instant('SEARCH.SEARCH'));
            this.googleTranslate.translate();
          } else {
            this.ns.renderError('Empty response');
          }
        },
        (error) => {
          this.loading = false;
          console.log(error);
          this.ns.renderError('Error', error);
        },
      );
  }

  normalizeQueryParams(searchString: string): string {
    let search = searchString.replace('q=', 'search_word=');

    if (!search.includes('dd_bunrui_cd') && search.includes('?')) {
      search += '&dd_bunrui_cd=01';
    }

    return search;
  }

  changePage(page: number): void {
    scrollToTop();
    this.router.navigate([], {
      queryParams: {
        page,
      },
      queryParamsHandling: 'merge',
    });
  }

  changePageSize(size: number): void {
    scrollToTop();
    this.router.navigate([], {
      queryParams: {
        per_page: size,
      },
      queryParamsHandling: 'merge',
    });
  }

  applyFilter(f: NgForm): void {
    this.router.navigate([], {
      queryParams: {
        new_flag: Number(f.value.new_flag),
        c_bunrui_cd: f.value.category ? f.value.category : null,
        s_bunrui_cd: f.value.detail ? f.value.detail.map((c) => c.value).join(',') : null,
        shouhin_maker_id: f.value.partmaker.length
          ? f.value.partmaker.map((p) => p.name).join(',')
          : null,
        shouhin_maker: f.value.partmaker.length
          ? f.value.partmaker.map((p) => p.value).join(',')
          : null,
        compatible_vehicle_maker_id: f.value.makerId ? f.value.makerId : null,
        compatible_vehicle_id: f.value.modelId ? f.value.modelId : null,
        free_shipping_flag: Number(f.value.free_shipping_flag),
        stars_division: f.value.stars_division ? f.value.stars_division * 10 : null,
        kakaku_low: f.value.kakaku_low ? Number(f.value.kakaku_low) : null,
        kakaku_high: f.value.kakaku_high ? Number(f.value.kakaku_high) : null,
        ...this.getSortQuery(f.value),
        page: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  resetFilter(f: NgForm): void {
    f.reset();
    this.router.navigate([], {
      queryParams: {
        new_flag: null,
        free_shipping_flag: null,
        arrival_date: null,
        update_date: null,
        kakaku: null,
        kakaku_low: null,
        kakaku_high: null,
        stars_division: null,
        star_rating: null,
        page: null,
        c_bunrui_cd: null,
        shouhin_maker_id: null,
        shouhin_maker: null,
        tekigou_shashu_id: null,
        tekigou_shashu_name: null,
        s_bunrui_cd: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  unsub(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onMakerChange(makerId: number) {
    this.models = [];
    this.crooberCarTypes.fetch({ makerId: makerId?.toString() }).subscribe((result) => {
      this.models = result.data.crooberCarTypes;
      this.googleTranslate.translate();
    });
  }

  ngOnDestroy(): void {
    this.unsub();
  }

  buy(item: any) {
    this.buying[item.code] = this.mhs.mutate(
      this.crooberOrderCreateGQL,
      {
        input: {
          itemId: item.code,
          quantity: 1,
          comment: '',
        },
      },
      {
        refetch: false,
        failureTranslationKey: 'AUCTION.LOT_BUY_FAIL',
        successTranslationKey: 'AUCTION.LOT_BUY_SUCCESS',
      },
    ).loading;
  }

  private getSortQuery(value) {
    return {
      arrival_date: value.sort === 'arrival_date' ? 'desc' : null,
      update_date: value.sort === 'update_date' ? 'desc' : null,
      kakaku: value.sort === 'price_up' ? 'asc' : value.sort === 'price_down' ? 'desc' : null,
      star_rating:
        value.sort === 'condition_up' ? 'asc' : value.sort === 'condition_down' ? 'desc' : null,
    };
  }
}
